<template>
  <div class="mk-autoweb-footer-menu">
    <div class="mk-autoweb-footer-menu-content">
      <div class="mk-autoweb-footer-menu-content-left">
        <div class="logo">
          <img :src="childItem.propsValue.data.customField1" alt />
        </div>
        <div class="rexian">
          <p>{{ childItem.propsValue.data.customField2 }}</p>
          <span>{{ childItem.propsValue.data.customField3 }}</span>
        </div>
        <div class="find">
          <p>联系我们</p>
          <div class="content">
            <div style="width: 90px;">
              <img :src="childItem.propsValue.data.customField4" alt />
            </div>
            <div style="width: 90px;">
              <img :src="childItem.propsValue.data.customField5" alt />
            </div>
          </div>
        </div>
      </div>
      <div class="mk-autoweb-footer-menu-content-right">
        <ul
          v-for="(firstMenu, firstIndex) in childItem.propsValue.data.customField6"
          :key="firstIndex"
        >
          <li>
            <span>{{ firstMenu.customField7 }}</span>
          </li>
          <li v-for="(secondMenu, secondIndex) in firstMenu.children" :key="secondIndex">
            <a>{{ secondMenu.customField7 }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MkFooterMenuWeb",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "logo",
          type: "image",
          width: 70,
          height: 50
        },
        {
          code: "customField2",
          label: "标题",
          type: "text"
        },
        {
          code: "customField3",
          label: "信息",
          type: "text"
        },
        {
          code: "customField4",
          label: "二维码1",
          type: "image",
          width: 180,
          height: 240
        },
        {
          code: "customField5",
          label: "二维码2",
          type: "image",
          width: 180,
          height: 240
        },
        {
          code: "customField6",
          label: "菜单",
          labelField: "customField7",
          type: "tree",
          maxLevel: 2,
          children: [
            {
              code: "customField7",
              label: "标题",
              type: "text"
            },
            {
              code: "customField8",
              label: "类型",
              type: "radio",
              defaultValue: "_self",
              data: [
                {
                  label: "当前页面打开",
                  value: "_self"
                },
                {
                  label: "新页签打开",
                  value: "_blank"
                }
              ]
            },
            {
              code: "customField9",
              label: "地址",
              type: "text"
            }
          ]
        }
      ],
      data: {
        customField1:
          "https://mks.yybip.com/group1/M00/01/B6/CgoRDGQbs4-AIop2AAAYwEY0BL4773.png",
        customField2: "售前咨询热线",
        customField3: "4006-600-577",
        customField4:
          "https://mkfs.yybip.com/static/yingxiao/yonyou_wx_publicaccount.jpg",
        customField5:
          "https://mkfs.yybip.com/static/yingxiao/qiyeweixin/default_zi.jpg",
        customField6: []
      }
    };
  }
};
</script>


<style lang="scss" scoped>
.mk-autoweb-footer-menu {
  background-color: #242424;
  width: 100%;
  min-height: 400px;
}

.mk-autoweb-footer-menu-content {
  max-width: 1680px;
  min-width: 880px;
  min-height: 400px;
  margin: 0 auto;
  display: flex;
}

.mk-autoweb-footer-menu-content-left {
  min-height: 350px;
  border-right: 1px solid #ffffff;
  margin: 30px 0 20px 30px;
  padding-right: 45px;
}

.mk-autoweb-footer-menu-content-left .logo img {
  width: 70px;
  height: 50px;
}

.mk-autoweb-footer-menu-content-left .rexian {
  margin-top: 20px;
  margin-bottom: 20px;
}

.mk-autoweb-footer-menu-content-left .rexian p {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: 8px;
}

.mk-autoweb-footer-menu-content-left .rexian span {
  font-size: 20px;
  color: #ffffff;
  font-weight: bold;
}

.mk-autoweb-footer-menu-content-left .find > p {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: 10px;
}

.mk-autoweb-footer-menu-content-left .find .content {
  display: flex;
  justify-content: space-between;
  width: 200px;
}

.mk-autoweb-footer-menu-content-left .find .content img {
  width: 90px;
}

.mk-autoweb-footer-menu-content-left .find .content p {
  font-size: 10px;
  color: #ffffff;
  text-align: center;
  margin-top: 3px;
}

.mk-autoweb-footer-menu-content-right {
  margin: 30px 0 20px 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex: 1;
}

.mk-autoweb-footer-menu-content-right ul {
  width: 120px;
  margin-right: 20px;
}

.mk-autoweb-footer-menu-content-right ul li {
  list-style: none;
}

.mk-autoweb-footer-menu-content-right ul li span {
  width: 100%;
  font-size: 18px;
  color: #ffffff;
  margin-bottom: 20px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mk-autoweb-footer-menu-content-right ul li a {
  width: 100%;
  text-decoration: none;
  color: #ffffff;
  font-size: 14px;
  margin-bottom: 14px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
